import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import PopularCoursesReport from '../../Reports/PopularCoursesReport';

export default function PopularCoursesPage(props) {
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.popular_courses')}
				category={I18n.t('admin.reports')}
			/>
			<PopularCoursesReport
				export_datatable_endpoint={props.export_datatable_endpoint}
				export_endpoint={props.export_endpoint}
				report={props.report}
			/>
		</div>
	);
}
